import Phaser from 'phaser';

/**
 * Filtrage des textures du décor selon le zoom de la caméra.
 *
 * - Zoom ≥ 100 % : plus proche voisin. Par défaut Phaser lisse (filtre
 *   linéaire) : au zoom d'une petite carte agrandie, meubles, sols et murs
 *   devenaient flous à côté des avatars.
 * - Zoom < 100 % : lissage. Au plus proche voisin, une réduction saute des
 *   pixels, et lesquels dépend du zoom exact : les traits d'un pixel (bords des
 *   tables, blocs-notes, points d'un tapis) apparaissaient et disparaissaient
 *   en dézoomant, le dessin changeait d'un cran de zoom à l'autre.
 *
 * Toute texture inscrite au gestionnaire (images et planches chargées,
 * canvases des tuiles extrudées et des tampons) suit ce réglage. Les textes
 * Phaser n'y passent pas (leur canvas n'est pas inscrit) et restent lissés.
 * `pixelArt: true` dans la config ferait aussi crénelés les textes.
 */
export function applyPixelFiltering(game: Phaser.Game): void {
  const { NEAREST, LINEAR } = Phaser.Textures.FilterMode;
  let mode: Phaser.Textures.FilterMode = NEAREST;
  // Réactions emoji (images 3D lisses, pas du pixel art) : toujours lissées.
  const applyTo = (texture: Phaser.Textures.Texture) =>
    texture.setFilter(texture.key.startsWith('reaction:') ? LINEAR : mode);
  const applyAll = () => {
    for (const key of game.textures.getTextureKeys()) applyTo(game.textures.get(key));
  };
  applyAll();
  game.textures.on(Phaser.Textures.Events.ADD, (_key: string, texture: Phaser.Textures.Texture) => applyTo(texture));
  // Une seule bascule quand le zoom franchit 100 %, pas un réglage par image.
  game.events.on(Phaser.Core.Events.PRE_RENDER, () => {
    const camera = game.scene.getScenes(true)[0]?.cameras?.main;
    if (!camera) return;
    const wanted = camera.zoom < 1 ? LINEAR : NEAREST;
    if (wanted === mode) return;
    mode = wanted;
    applyAll();
  });
}
